import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeroPrimary.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import clsx from 'clsx';
import { canUseDOM, get, getColorByTheme, getPageThemeColors, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import RouterLink from '../atoms/RouterLink';
import Loader from '../atoms/Loader/Loader';
import { useModal } from '../atoms/Modal/useModal';
import Modal from '../atoms/Modal/Modal';
import { ReactComponent as IconPlay } from '../../resources/icons/IconPlay2.svg';
import { ReactComponent as IconPlay3 } from '../../resources/icons/IconPlay3.svg';
import { ReactComponent as IconPauseItem } from '../../resources/icons/IconPauseFat.svg';
import throttle from 'lodash/throttle';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { ReactComponent as IconDblArrowDown } from '../../resources/icons/IconDblArrowDown.svg';
import { ReactComponent as IconChevronRight } from '../../resources/icons/chevron-bold.svg';
import Video from '../atoms/Video';
var emptyModalVideo = {
  src: '',
  type: '',
  title: '',
  playing: false,
  loading: true,
  visiblePlayButton: true
};
var HeroPrimary = function HeroPrimary(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var fields = props.fields,
    params = props.params;
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var heroWrapperRef = useRef(null);
  var modalVideo = useRef(null);
  var slides = get(fields, 'data.item.children', []);
  var _useState = useState(emptyModalVideo),
    _useState2 = _slicedToArray(_useState, 2),
    modalVideoState = _useState2[0],
    setModalVideoState = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    carouselAutoplay = _useState4[0],
    setCarouselAutoplay = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isVdsite = _useState6[0],
    setIsVdsite = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    navbarHeightStyle = _useState8[0],
    setNavbarHeightStyle = _useState8[1];
  var _useModal = useModal(),
    isShown = _useModal.isShown,
    toggle = _useModal.toggle;
  var actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  var isMobile = useMemo(function () {
    return !actualSSR && canUseDOM && window.matchMedia("(max-width: 991px)").matches;
  }, [actualSSR]);
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var checkMouseMoved;
  if (canUseDOM) {
    checkMouseMoved = throttle(function () {
      if (!modalVideoState.visiblePlayButton) {
        setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
          visiblePlayButton: true
        }));
      }
    }, 300);
  }
  useEffect(function () {
    if (modalVideoState.type === 'media') {
      var timer;
      if (modalVideoState.visiblePlayButton) {
        timer = setTimeout(function () {
          setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
            visiblePlayButton: false
          }));
        }, 2000);
      }
      return function () {
        clearTimeout(timer);
      };
    }
  }, [modalVideoState]);
  useEffect(function () {
    if (canUseDOM) {
      var header = document.querySelector('header');
      setNavbarHeightStyle({
        '--navbar-height': header ? "".concat(header.offsetHeight, "px") : '0px'
      });
    }
  }, []);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var carouselSpeed = get(params, 'timeout');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    "--m57-hero-primary-background-color": BackgroundColorHex,
    "--m57-hero-primary-background-active-color": ActiveColorHex,
    "--m57-hero-primary-color": ColorHex
  } : {
    "--m57-hero-primary-background-color": selectedPrimaryColor,
    "--m57-hero-primary-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-hero-primary-color": getColorByTheme(selectedPrimaryColor)
  };
  if (!fields) {
    console.info('Hero component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [Hero component is empty: please provide data source]");
    }
    return null;
  }
  var renderItems = function renderItems() {
    return slides.map(function (slide) {
      var src = get(slide, 'image.jss.value.src', '');
      var alt = get(slide, 'image.jss.value.alt', '');
      var title = get(slide, 'title.jss');
      var hasTitle = get(slide, 'title.jss.value');
      var intro = get(slide, 'description.jss');
      var hasIntro = get(slide, 'description.jss.value');
      var primaryCtaHref = get(slide, 'cTALink.jss.value.href');
      var primaryCtaLabel = get(slide, 'cTALinkLabel.jss.value');
      var primaryCtaTarget = get(slide, 'cTALink.jss.value.target');
      var primaryCtaLinktype = get(slide, 'cTALink.jss.value.linktype');
      var secondaryCtaHref = get(slide, 'cTASecondaryLink.jss.value.href');
      var secondaryCtaLabel = get(slide, 'cTASecondaryLinkLabel.jss.value');
      var secondaryCtaTarget = get(slide, 'cTASecondaryLink.jss.value.target');
      var secondaryCtaLinktype = get(slide, 'cTASecondaryLink.jss.value.linktype');
      var videoSrc = get(slide, 'video.jss.value.href', '');
      var videoType = get(slide, 'video.jss.value.linktype');
      var modalVideoDesk = get(slide, 'secondaryVideoLink.jss.value', {});
      var modalVideoMobile = get(slide, 'secondaryMobileVideoLink.jss.value', {});
      var hasPrimaryLink = primaryCtaHref && primaryCtaLabel;
      var hasSecondaryLink = secondaryCtaLabel && (secondaryCtaHref || modalVideoDesk.linktype || modalVideoMobile.linktype);
      var renderPrimary = function renderPrimary(className) {
        return /*#__PURE__*/React.createElement(RouterLink, {
          href: primaryCtaHref,
          className: className,
          title: primaryCtaLabel,
          linksTarget: primaryCtaTarget,
          linktype: primaryCtaLinktype,
          onClick: function onClick() {
            return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, primaryCtaLabel]);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "btn__text-wrapper"
        }, primaryCtaLabel));
      };
      var renderSecondary = function renderSecondary() {
        if (modalVideoDesk.linktype || modalVideoMobile.linktype) {
          return /*#__PURE__*/React.createElement("button", {
            className: "btn btn-secondary-mono btn--iconed",
            onClick: function onClick() {
              tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, secondaryCtaLabel]);
              var finalVideo;
              if (isMobile) {
                finalVideo = modalVideoMobile.linktype ? modalVideoMobile : modalVideoDesk;
              } else {
                finalVideo = modalVideoDesk.linktype ? modalVideoDesk : modalVideoMobile;
              }
              setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
                type: finalVideo.linktype,
                src: finalVideo.href,
                title: hasTitle
              }));
              toggle();
              setCarouselAutoplay(false);
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "btn__icon"
          }, /*#__PURE__*/React.createElement(IconPlay3, null)), /*#__PURE__*/React.createElement("span", {
            className: "btn__text-wrapper"
          }, secondaryCtaLabel));
        }
        return /*#__PURE__*/React.createElement(RouterLink, {
          href: secondaryCtaHref,
          className: "btn btn-secondary-mono",
          title: secondaryCtaLabel,
          linksTarget: secondaryCtaTarget,
          linktype: secondaryCtaLinktype,
          onClick: function onClick() {
            return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, secondaryCtaLabel]);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "btn__text-wrapper"
        }, secondaryCtaLabel));
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "item-wrapper ".concat(pageEditing ? iteminEEStyles : '')
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        className: "",
        useEmptyPlaceholder: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: "".concat(injectImageResolution(src, 1920, 888))
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: "".concat(injectImageResolution(src, 1024, 474))
      }), /*#__PURE__*/React.createElement("img", {
        src: "".concat(injectImageResolution(src, 750, 1164)),
        alt: alt,
        className: "slider__image"
      })), videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
        buttonTopAlignment: true,
        videoSrc: videoSrc,
        videoType: videoType,
        click: function click(e) {
          return tealiumClickFunc(params, "".concat(e, ": ").concat(videoSrc));
        },
        disableFocusableOnMount: true,
        muted: true,
        autoplay: true,
        videoFullHeight: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "texts"
      }, hasTitle && /*#__PURE__*/React.createElement(Text, {
        tag: "h1",
        className: "title",
        field: title
      }), hasIntro && /*#__PURE__*/React.createElement(Text, {
        tag: "p",
        className: "intro",
        field: intro
      }), /*#__PURE__*/React.createElement("div", {
        className: "btns-wrapper"
      }, hasPrimaryLink && renderPrimary(hasSecondaryLink ? 'btn btn-secondary-lokalized' : 'btn btn-secondary-mono'), hasSecondaryLink && renderSecondary())));
    });
  };
  var scroolToElement = function scroolToElement() {
    if (heroWrapperRef.current) {
      window.scrollTo({
        top: window.scrollY + heroWrapperRef.current.getBoundingClientRect().bottom,
        behavior: 'smooth'
      });
    }
  };
  var modalPlayButtonHandler = function modalPlayButtonHandler() {
    if (modalVideo.current) {
      if (modalVideoState.playing) {
        modalVideo.current.pause();
      } else {
        modalVideo.current.play();
      }
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        playing: !modalVideoState.playing
      }));
    }
  };
  var renderVideo = function renderVideo(styles) {
    if (!modalVideoState.src || !modalVideoState.type) {
      return null;
    }
    if (modalVideoState.type === 'external') {
      return /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          toggle();
          setModalVideoState(emptyModalVideo);
          setCarouselAutoplay(true);
        },
        className: clsx(styles, 'modal-yt-iframe-container')
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-yt-iframe-ar-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        width: "560",
        height: "315",
        src: modalVideoState.src,
        title: modalVideoState.title,
        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerPolicy: "strict-origin-when-cross-origin",
        allowFullScreen: true,
        className: "modal-yt-iframe"
      })));
    }
    if (modalVideoState.type === 'media') {
      return /*#__PURE__*/React.createElement("div", {
        onMouseMove: checkMouseMoved,
        className: clsx(styles, {
          'hidden-play-button': !modalVideoState.visiblePlayButton
        })
      }, /*#__PURE__*/React.createElement("video", {
        ref: modalVideo,
        className: clsx('modal-video', {
          'modal-video--load-over': !modalVideoState.loading
        }),
        playsInline: true,
        loop: true,
        onProgress: function onProgress() {
          if (modalVideoState.loading) {
            setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
              loading: false
            }));
          }
        },
        muted: false,
        preload: "auto",
        autoPlay: false
      }, /*#__PURE__*/React.createElement("source", {
        src: modalVideoState.src,
        type: "video/mp4"
      }), /*#__PURE__*/React.createElement("track", {
        kind: "captions"
      })), modalVideoState.loading ? /*#__PURE__*/React.createElement(Loader, {
        color: "#000000"
      }) : /*#__PURE__*/React.createElement("button", {
        className: clsx('btn--reset modal-play-button', {
          'modal-play-button--playing': modalVideoState.playing
        }),
        onClick: modalPlayButtonHandler
      }, modalVideoState.playing ? /*#__PURE__*/React.createElement(IconPauseItem, null) : /*#__PURE__*/React.createElement(IconPlay, null)));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: _objectSpread(_objectSpread({}, variables), navbarHeightStyle),
    fullWidth: true
  }, pageEditing ? function () {
    return renderItems();
  } : function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "hero",
      ref: heroWrapperRef
    }, /*#__PURE__*/React.createElement("button", {
      className: "slide-down-btn",
      "aria-label": "slide down button",
      onClick: scroolToElement
    }, /*#__PURE__*/React.createElement(IconDblArrowDown, {
      className: ""
    })), /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref) {
      var renderCarousel = _ref.renderCarousel,
        renderPreviousButton = _ref.renderPreviousButton,
        renderNextButton = _ref.renderNextButton,
        renderDots = _ref.renderDots,
        state = _ref.state;
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItems(), {
        responsive: {
          desktop: {
            breakpoint: {
              max: 10000,
              min: 1024
            },
            items: 1
          },
          mobile: {
            breakpoint: {
              max: 1023,
              min: 0
            },
            items: 1
          }
        },
        autoPlay: carouselAutoplay,
        autoPlaySpeed: carouselSpeed ? Number(carouselSpeed) * 1000 : 7000,
        infinite: slides.length !== 1
      }, function () {
        return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['mobileSlidesAnalytics'], params));
      }), /*#__PURE__*/React.createElement("div", {
        className: "hero-carousel__control my-icon-white--mono hero-carousel__control--prev d-none d-md-block"
      }, renderPreviousButton(function () {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextPrevAnalytics'], params), 'Previous');
      }, true, false, /*#__PURE__*/React.createElement(IconChevronRight, {
        className: "icon"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "hero-carousel__control my-icon-white--mono hero-carousel__control--next d-none d-md-block"
      }, renderNextButton(function () {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextPrevAnalytics'], params), 'Next');
      }, true, false, /*#__PURE__*/React.createElement(IconChevronRight, {
        className: "icon"
      }))), renderDots(function () {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params));
      }, slides.map(function (slide) {
        return {
          title: get(slide, 'title.jss.value'),
          thumbUrl: injectImageResolution(get(slide, 'image.jss.value.src', ''), 143, 80),
          thumbAlt: get(slide, 'image.jss.value.alt', '')
        };
      })));
    })), /*#__PURE__*/React.createElement(Modal, {
      showMobileClose: true,
      fullPageCover: true,
      fullPageVideo: true,
      isShown: isShown,
      hide: function hide() {
        if (modalVideo.current && modalVideoState.playing) {
          modalVideo.current.pause();
        }
        toggle();
        setModalVideoState(emptyModalVideo);
        setCarouselAutoplay(true);
      }
    }, actualSSR ? null : renderVideo(videplayerStyles)));
  });
};
var videplayerStyles = "v1cpmtbu";
var iteminEEStyles = "iar8tqu";
var commonStyles = "c7u1w5q";
var ltrStyles = "l1uhhlzl";
var rtlStyles = "r1ogasw4";
export default HeroPrimary;